'use client';

import { useCallback } from 'react';
import { Card, CardActionArea, Skeleton, Stack } from '@mui/material';
import { TenantConfig } from '@/shared/types/controllers/sps/SPSAppControllerTypes';
import { PartRelevantPartsDataResponse } from '@/shared/types/controllers/sps/SPSPartControllerTypes';
import { generatePartURL } from '@/shared/utils/URLs';
import { PartCardHorizontalInner } from './components/PartCardHorizontalInner';
type PartCardHorizontalProps = {
  tenantConfig: TenantConfig;
  part: PartRelevantPartsDataResponse['parts'][0];
  onClick?: () => void;
};
export const PartCardHorizontal = ({
  tenantConfig,
  part,
  onClick
}: PartCardHorizontalProps) => {
  const href = generatePartURL(part.manufacturer.name, part.partNumber, part.id);
  const onPartView = useCallback(() => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);
  return <Card sx={{
    borderWidth: '2px',
    borderColor: 'primary.12p',
    mb: {
      xs: 1,
      borderRadius: 0
    }
  }} data-sentry-element="Card" data-sentry-component="PartCardHorizontal" data-sentry-source-file="PartCardHorizontal.tsx">
      <CardActionArea onClick={onPartView} href={href} data-sentry-element="CardActionArea" data-sentry-source-file="PartCardHorizontal.tsx">
        <PartCardHorizontalInner part={part} tenantConfig={tenantConfig} data-sentry-element="PartCardHorizontalInner" data-sentry-source-file="PartCardHorizontal.tsx" />
      </CardActionArea>
    </Card>;
};
export const PartCardHorizontalSkeleton = () => <Card data-sentry-element="Card" data-sentry-component="PartCardHorizontalSkeleton" data-sentry-source-file="PartCardHorizontal.tsx">
    <Stack direction="row" spacing={2} sx={{
    width: '100%',
    py: 1,
    px: 1.5,
    minWidth: 200
  }} data-sentry-element="Stack" data-sentry-source-file="PartCardHorizontal.tsx">
      <Skeleton variant="rectangular" width={50} height={50} sx={{
      flexShrink: 0
    }} data-sentry-element="Skeleton" data-sentry-source-file="PartCardHorizontal.tsx" />
      <Stack spacing={1} sx={{
      width: '100%'
    }} data-sentry-element="Stack" data-sentry-source-file="PartCardHorizontal.tsx">
        <Skeleton width={100} data-sentry-element="Skeleton" data-sentry-source-file="PartCardHorizontal.tsx" />
        <Skeleton data-sentry-element="Skeleton" data-sentry-source-file="PartCardHorizontal.tsx" />
        <Skeleton width={60} data-sentry-element="Skeleton" data-sentry-source-file="PartCardHorizontal.tsx" />
      </Stack>
    </Stack>
  </Card>;